import { queryOptions } from '@tanstack/react-query'

import { getLocationDetail, searchLocation } from './locations.service'

export const locationsQueries = {
  all: () => ['locations'],
  lists: () => [...locationsQueries.all(), 'list'],
  list: (searchText: string) =>
    queryOptions({
      queryKey: [...locationsQueries.lists(), searchText],
      queryFn: () => searchLocation(searchText),
    }),
  details: () => [...locationsQueries.all(), 'detail'],
  detail: (locationRef: string) =>
    queryOptions({
      queryKey: [...locationsQueries.details(), locationRef],
      queryFn: () => getLocationDetail(locationRef),
    }),
}
